import { Challenge, ChallengeWithUser } from '../../domain/models';
import { ChallengeRepository } from '../../domain/repositories';
import { ChallengeDataSource } from '../datasources/ChallengeDataSource';
import { challengeEntityToModel, challengeWithUserEntityToModel } from '../entities';

export class ChallengeRepositoryImpl implements ChallengeRepository {
  constructor(private dataSource: ChallengeDataSource) {}

  async sendChallenge(
    challengerId: string,
    challengedId: string,
    message?: string
  ): Promise<Challenge> {
    const entity = await this.dataSource.create(challengerId, challengedId, message);
    return challengeEntityToModel(entity);
  }

  async acceptChallenge(challengeId: string, tournamentId: string): Promise<Challenge> {
    const entity = await this.dataSource.update(challengeId, 'accepted', tournamentId);
    return challengeEntityToModel(entity);
  }

  async declineChallenge(challengeId: string): Promise<Challenge> {
    const entity = await this.dataSource.update(challengeId, 'declined');
    return challengeEntityToModel(entity);
  }

  async cancelChallenge(challengeId: string): Promise<Challenge> {
    const entity = await this.dataSource.update(challengeId, 'cancelled');
    return challengeEntityToModel(entity);
  }

  async getChallengesReceived(
    userId: string,
    limit?: number,
    offset?: number
  ): Promise<ChallengeWithUser[]> {
    const entities = await this.dataSource.getChallengesReceived(userId, limit, offset);
    return entities.map(challengeWithUserEntityToModel);
  }

  async getChallengesSent(
    userId: string,
    limit?: number,
    offset?: number
  ): Promise<ChallengeWithUser[]> {
    const entities = await this.dataSource.getChallengesSent(userId, limit, offset);
    return entities.map(challengeWithUserEntityToModel);
  }
}
